<template>
	<div
		class="p-input"
		:class="classes"
	>
		<div class="p-input__wrapper">
			<div class="p-input__input">
				<i
					v-if="iconName?.length"
					class="p-icon"
					:class="`p-icon-${iconName}`"
				/>
				<input
					v-bind="$attrs"
					:disabled="disabled"
					:value="value"
					:placeholder="placeholder"
					:type="type === 'password' ? passwordType : type"
					@focus="onFocus"
					@blur="onBlur"
          v-maska="mask"
				>
				<template v-if="type === 'password'">
					<component
						:is="passwordType === 'text' ? EyeOpenedIcon : EyeClosedIcon"
						class="password__eye"
						@click="togglePassword"
					/>
				</template>
				<slot name="icon" />
				<popper
					v-if="isTooltip"
					v-bind="tooltipProps"
					:class="'p-input__popover'"
				>
					<i
						class="p-icon p-icon-info"
						:class="{'p-icon-error': !valid && tooltipInfo.length === 0}"
					/>
					<template #content>
						<div class="p-popover__content">
							{{ cTooltipInfo }}
						</div>
					</template>
				</popper>
			</div>
			<div
				v-if="isLabel"
				class="p-input__label"
			>
				{{ label }}
			</div>
			<div
				v-if="!valid && !isTooltip"
				class="p-input__info"
			>
				{{ validInfo }}
			</div>
		</div>
	</div>
</template>
<script setup lang="ts">
import { vMaska } from "maska/vue"
import {computed , ref} from 'vue';
import Popper from 'vue3-popper';
import EyeOpenedIcon from '@/common/icons/EyeOpenedIcon.vue';
import EyeClosedIcon from '@/common/icons/EyeClosedIcon.vue';

interface Props {
	valid?: boolean;
	validInfo?: string;
	value?: any;
	disabled?: boolean;
	label?: string;
	iconName?: string,
	outLabel?: boolean;
	isTooltip?: boolean;
	tooltipInfo?: string;
	tooltipProps?: object;
	placeholder?: string;
  mask?: string;
	type?: string
}

// Props
const props = withDefaults(defineProps<Props>(), {
	valid: true, 
	outLabel: false, 
	tooltipInfo: '', 
	mask: '', 
	placeholder: '',
  isPassword: 'text'
});

// Refs
const focus = ref(false);
const passwordType = ref('password');

// Computed
const classes = computed(() => ({
	'p-input_default': true,
	'p-input_focus': focus.value || props.value,
	'p-input_out-label': props.outLabel,
	'p-input_error': !props.valid,
	'p-input_icon': props.iconName,
	'p-input_disabled': props.disabled,
	'p-input_success': props.valid && props.value !== null && props.value.length > 0 && typeof props.value !== 'undefined'
}));
const isLabel = computed(() => {
	return props.label?.length;
});
const cTooltipInfo = computed( () => {
	return props.tooltipInfo.length !== 0 ? props.tooltipInfo : props.validInfo;
});

// Methods
const onFocus = () => {
	focus.value = true;
};
const onBlur = () => {
	focus.value = false;
};

const togglePassword = () => {
  passwordType.value = passwordType.value === 'password' ? 'text' : 'password';
};
</script>

<style>
@import "styles/pInput.scss";
</style>